// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3a671a22","703":"7cdf24b3","787":"1bf1c336"}[chunkId] + ".chunk.js";
};